import { useEffect } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
    usersState,
    usersRefreshTrigger,
    usersByUsernameState,
    userDisplayNamesState,
} from "../atoms/userAtoms";
import { listUsers } from "@/services/userService";
import type { User } from "../../amplify/api/types";

export function useUsers() {
    const [users, setUsers] = useRecoilState(usersState);
    const setRefreshTrigger = useSetRecoilState(usersRefreshTrigger);
    const usersByUsername = useRecoilValue(usersByUsernameState);
    const userDisplayNames = useRecoilValue(userDisplayNamesState);
    
    // Function to refresh users
    const refreshUsers = () => {
        setRefreshTrigger((prev) => prev + 1);
    };
    
    // Load users on initial mount and when refresh is triggered
    const refreshTrigger = useRecoilValue(usersRefreshTrigger);
    
    useEffect(() => {
        const loadUsers = async () => {
            try {
                const fetchedUsers = await listUsers();
                setUsers(fetchedUsers);
            } catch (error) {
                console.error("Failed to load users:", error);
            }
        };
        
        loadUsers();
    }, [refreshTrigger, setUsers]);
    
    // Helper function to get user display name by username
    const getUserDisplayName = (username: string): string => {
        return userDisplayNames[username] || username;
    };
    
    // Helper function to get user by username
    const getUserByUsername = (username: string): User | undefined => {
        return usersByUsername[username];
    };
    
    return {
        users,
        usersByUsername,
        userDisplayNames,
        refreshUsers,
        getUserDisplayName,
        getUserByUsername,
    };
}